export const getPreConfig = item => {
  const { sceneStatus } = item
  switch (Number(sceneStatus)) {
    case 2:
      return {
        tipsStyle: {
          color: '#FB992E',
          background: 'rgba(251, 153, 46, 0.08)'
        },
        icon: 'ClockCircleOutlined',
        isClickCard: false //卡片是否可以点击
      }
    case 3:
    case 4:
      return {
        tipsStyle: {
          color: '#24BCA2',
          background: 'rgba(36, 188, 162, 0.08)'
        },
        icon: 'CheckCircleOutlined',
        isClickCard: true
      }
    case 5:
    case 6:
    case 7:
      return {
        tipsStyle: {
          color: '#F84F4F',
          background: 'rgba(248, 79, 79, 0.08)'
        },
        icon: 'ExclamationCircleOutlined',
        isClickCard: false
      }
    default:
      return {
        tipsStyle: {
          color: '#FB992E',
          background: 'rgba(251, 153, 46, 0.08)'
        },
        icon: 'ClockCircleOutlined',
        isClickCard: false
      }
  }
}
